import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  NavController,
  NavParams,
} from "ionic-angular";
import { User } from "../../services/user";
import { Api } from "../../services/api";
import { BindAccountPage } from "../bind-account/bind-account";
import { WeixinQr } from "../../services/weixin_qr";
import { ShareCard } from "../../services/sharecard";

const groupBuySuccessfulHintMute = "group_buy_successful_hint_mute";

@IonicPage({
  segment: "order/:id",
})
@Component({
  selector: "page-order-detail",
  templateUrl: "order-detail.html",
})
export class OrderDetailPage {
  data;
  window = window;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private user: User,
    private api: Api,
    private alertCtrl: AlertController,
    public weixinQr: WeixinQr,
    private shareCard: ShareCard
  ) {}

  ionViewDidLoad() {
    this.api.collect({
      event: "order-detail",
      attr: { id: this.navParams.data.id },
    });
  }

  ionViewDidEnter() {
    document.title = "订单详情";
    this.shareCard.share({
      title: "订单详情",
      desc: "订单详情",
      link: location.href,
      imgUrl: "",
    });

    this.fetchData();
  }

  fetchData() {
    this.api.getOrderDetail(this.navParams.data.id).then((_) => {
      this.data = _;
      if (this.data.stock.auto_activated_for == "0") {
        this.data.stock.auto_activated_for = null;
      }
      let searchString = this.navParams.data.id + ",";
      if (
        (localStorage[groupBuySuccessfulHintMute] || "").indexOf(searchString) <
        0
      ) {
        localStorage[groupBuySuccessfulHintMute] =
          (localStorage[groupBuySuccessfulHintMute] || "") + searchString;
      }
    });
  }

  showCampaign() {
    window.location.hash = "/campaign/" + this.data.id;
  }

  openLink() {
    let code = this.data.stock ? this.data.stock.code : "";
    window.location.assign(
      this.data.item.stock_redeem_link.replace(/\${code}/g, code)
    );
  }

  openCode() {
    let code = this.data.stock ? this.data.stock.code : "";
    this.alertCtrl
      .create({
        title: "复制代码",
        subTitle: "请长按复制",
        cssClass: "big-input-alert",
        enableBackdropDismiss: false,
        inputs: [
          {
            value: code,
          },
        ],
        buttons: [
          {
            text: "关闭",
            role: "cancel",
          },
        ],
      })
      .present()
      .then((_) => {
        try {
          (document.body.querySelector(".alert-input") as any).select();
        } catch (ex) {}
      });
  }

  doBindAccount() {
    window["bindAccountCallback"] = null;
    this.navCtrl.push(BindAccountPage);
  }

  showWeixinQr() {
    return this.weixinQr.show(this.data.item.qr_url, this.data.item.name);
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-detail/order-detail.ts